import { render } from "./MermaidDiagram.vue?vue&type=template&id=18df8c33&scoped=true"
import script from "./MermaidDiagram.vue?vue&type=script&lang=js"
export * from "./MermaidDiagram.vue?vue&type=script&lang=js"

import "./MermaidDiagram.vue?vue&type=style&index=0&id=18df8c33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18df8c33"]])

export default __exports__